import { Injectable } from '@angular/core';
import { MOCEvent } from '../../model/crm/moc-event';
import { BaseTableService } from './base-table.service';
import { MOCEventSearch } from 'src/app/model/crm/moc-event-search';

@Injectable({
  providedIn: 'root',
})
export class MocEventTableService extends BaseTableService<MOCEventSearch> {
  constructor() {
    super();
  }
}
